import { render, staticRenderFns } from "./ViewEmpleado.vue?vue&type=template&id=c0c84f02&"
import script from "./ViewEmpleado.vue?vue&type=script&lang=js&"
export * from "./ViewEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewEmpleado.vue"
export default component.exports